import React from 'react';

import './HeaderLink.scss';

export default ({ content, ...rest }) => {
  return <a {...rest}>{content}</a>;
};
